import React from 'react';
import './LoadingSpinner.css';

interface Props {
  fullPage?: boolean;
  small?: boolean;
}

export default function LoadingSpinner({ fullPage, small }: Props) {
  return (
    <div className={`spinner-container${fullPage ? ' spinner--fullpage' : ''}${small ? ' spinner-container--small' : ''}`}>
      <div className={`spinner${small ? ' spinner--small' : ''}`} />
    </div>
  );
}
